<div class="order" *ngIf="this.orders && this.orders.length==1">
    <div class="d-flex justify-content-between">
        <h2 class="order_title">Order details</h2>
    </div>

    <hr class="order_border_space">
    <ul>
        <li class="d-flex order_details">
            <label class="order_text order_details_label flex-shrink-0">Order ID</label>
            <p class="order_text order_gray flex-shrink-1">
                <span class="order_details_lclone">:</span>
                <span class="order_text_gray">{{lastOrder?.Orderid}}</span>
                <i class="fal --copy" [ngClass]="{ 'fa-copy': !copied, 'fa-check': copied }"
                    [cdkCopyToClipboard]="lastOrder?.Orderid" (cdkCopyToClipboardCopied)="copy($event)">
                </i>
            </p>
        </li>
        <li class="d-flex order_details">
            <label class="order_text order_details_label flex-shrink-0">Purchased on</label>
            <p class="order_text order_gray flex-shrink-1">
                <span class="order_details_lclone">:</span>
                <span class="order_text_gray">
                    {{lastOrder?.Purchased | date:"short"}}
                </span>
            </p>
        </li>
        <li class="d-flex order_details">
            <label class="order_text order_details_label flex-shrink-0">Order Status</label>
            <p class="order_text order_gray flex-shrink-1 order_details--shipped">
                <span class="order_details_lclone">:</span>
                <span class="order_status--{{ lastOrder?.Status??'' | lowercase }}">
                    <i class="far " [ngClass]="{
                            'fa-clock': lastOrder?.Status === 'Working',
                            'fa-check-circle': lastOrder?.Status === 'Completed' || lastOrder?.Status === 'Shipped',
                            'fa-archive': lastOrder?.Status === 'Shipping',
                            'fa-hourglass': lastOrder?.Status === 'Pending' || lastOrder?.Status === 'Unshipped',
                            'fa-times-circle': lastOrder?.Status === 'Cancelled' || lastOrder?.Status === 'Canceled'||
                            lastOrder?.Status === 'Closed' ||  lastOrder?.Status === 'Deleted'}">
                    </i>
                    {{ lastOrder?.Status??"" | textCapitalize}}
                </span>
            </p>
        </li>
        <li class="d-flex order_details">
            <label class="order_text order_details_label flex-shrink-0">Qty</label>
            <p class="order_text order_gray flex-shrink-1"><span class="order_details_lclone">:</span>
                <span class="order_text_gray">
                    {{lastOrder?.qty}}
                </span>
            </p>
        </li>
        <li class="d-flex order_details">
            <label class="order_text order_details_label flex-shrink-0">Store</label>
            <p class="order_text order_gray flex-shrink-1"><span class="order_details_lclone">:</span>
                <span class="order_text_gray">
                    {{lastOrder?.account }}
                </span>

            </p>
        </li>
        <li class="d-flex order_details">
            <label class="order_text order_details_label flex-shrink-0">Channel</label>
            <p class="order_text order_gray flex-shrink-1">
                <span class="order_details_lclone">:</span>
                <span class="order_text_gray">
                    {{lastOrder?.accountType}} 
                </span>
            </p>
        </li>
    </ul>
    <hr class="order_border_space">
    <h3 class="order_title order_accordion" (click)="isShowFulfilment=!isShowFulfilment">
        <span class="order_accordion_arrowIcon" [class.rotate]="isShowFulfilment">
            <i class="fas fa-caret-right"></i>
        </span>
        Fulfilment
    </h3>
    <div class="order_item_single">
        <ng-container *ngIf="isShowFulfilment">
            <ng-template [cdkPortalOutlet]="fulfilmentComponentPortal"
                (attached)="onFulfilmentComponentRendering($event)">
            </ng-template>
            <h3 class="order_title d-flex align-items-center justify-content-between mx-2">Shipping with
                <!-- <app-button [buttonStyle]="'text'" 
                *ngIf="!loadingShipStation && shipStation && (shipStation | json) !='{}' && lastOrder?.Status !== 'Shipped'"
                 (click)="openShipping()">Show all </app-button> -->
                </h3>  
            <div *ngIf="!loadingShipStation && shipStation && (shipStation | json) !='{}' && lastOrder?.Status !== 'Shipped'">
                <form [formGroup]="shipOrderForm">
                    <div class="input-container">
                        <label class="input-container_label">Service</label>
                        <mat-form-field appearance="fill" class="custom-mat-select">
                            <mat-select class="input-container_input input-container_input--select" formControlName="service" disableOptionCentering panelClass="select-content-box print-option">
                            <mat-option (click)="refreshService()" class="refresh-option" disabled>Refresh carrier list</mat-option> 
                                <mat-optgroup *ngFor="let ship of shipstationCarriers;let i = index" [label]="ship.name">
                                <mat-option *ngFor="let child of ship.service;let j = index" [value]="child.name" (click)="onServiceChange(i,j)">
                                    {{child.name}} 
                                </mat-option>
                                </mat-optgroup>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="input-container">
                        <label class="input-container_label">Package</label> 
                        <mat-form-field appearance="fill" class="custom-mat-select">
                            <mat-select class="input-container_input input-container_input--select" formControlName="package" disableOptionCentering panelClass="select-content-box print-option">
                                <mat-optgroup *ngFor="let ship of shipCarrierPackage;let i = index" [label]="ship.name">
                                    <mat-option *ngFor="let child of ship.package;let j = index" [value]="child.name" (click)="onPackageChange(i,j)">
                                        {{child.name}} 
                                    </mat-option>
                                </mat-optgroup>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="order_summary" *ngIf="!rateError">Total: {{totalRate | currency}}</div>
                    <div class="order_error" *ngIf="rateError"><span [matTooltip]="'We cannot use this service and package type.Try with other service or package'">
                        <i class="fas fa-exclamation-triangle me-2"></i>Rate Error</span>
                    </div>
                </form>
            </div>
            <div class="order_shiping order-batch-shiping d-flex align-items-center flex-wrap justify-content-between"
                *ngIf="loadingShipStation || !shipStation || (shipStation|json)=='{}' || lastOrder?.Status === 'Shipped'">
                <app-no-results [message]="loadingShipStation ? 'Loading Ship Station Info' : 'No result found'">
                </app-no-results>
            </div>
            <div class="footer">
                <div class="footer-info footer-remove d-flex align-items-center"
                    [class.disable-click]="!shipStation || lastOrder?.BatchsId<1" (click)="onRemoveFromBatch()">
                    <i class="footer-info-icon">
                        <img [src]="minusIcon" alt="">
                    </i>
                    <span class="footer-info-text footer-remove-text">Remove from batch</span>
                </div>
                <div class="footer-info footer-shipped d-flex align-items-center"
                    [class.disable-click]="!shipStation || lastOrder?.Status === 'Shipped'" (click)="onMarkasShipped()">
                    <i class="footer-info-icon">
                        <img [src]="markPickedIcon" alt="">
                    </i>
                    <span class="footer-info-text">Mark as shipped</span>
                </div>
                <div class="footer-info d-flex align-items-center"
                    [class.disable-click]="!shipStation || (shipStation | json) ==='{}'" (click)="onPrintPickingSlip()">
                    <i class="far fa-print footer-info-icon"></i>
                    <span class="footer-info-text">Print packing slip</span>
                </div>
                <app-button [spin]="isSpinningPrintLabel"
                    [isDisabled]="isDisabledPrintLabel ||  (shipStation | json) ==='{}'"
                    (click)="printLabelUsingUrl()">
                    Print label
                </app-button>
            </div>
        </ng-container>
    </div>
    <h3 class="order_title order_accordion" (click)="isShowSku=!isShowSku">
        <span class="order_accordion_arrowIcon" [class.rotate]="isShowSku">
            <i class="fas fa-caret-right"></i>
        </span>
        SKU’s
    </h3>
    <div class="order_item_single">
        <ng-container *ngIf="isShowSku">
            <ng-template [cdkPortalOutlet]="skuComponentPortal" (attached)="onskuComponentRendering($event)">
            </ng-template>
        </ng-container>
    </div>
    <h3 class="order_title order_accordion" (click)="isShowFinancial=!isShowFinancial">
        <span class="order_accordion_arrowIcon" [class.rotate]="isShowFinancial">
            <i class="fas fa-caret-right"></i>
        </span>
        Financial Details
    </h3>
    <div class="order_item_single">
        <ng-container>
            <ng-template [cdkPortalOutlet]="financialComponentPortal"
                (attached)="onFinancialComponentRendering($event)">
            </ng-template>
        </ng-container>
    </div>
</div>
<div class="order_prev_next d-flex justify-content-between">
    <app-button (click)="onPrevious()" [class.disable-click]="currentNode?.rowIndex==0" type="button" name="previous">
        <i class="fal fa-chevron-left me-1"></i>
        Previous
    </app-button>
    <app-button (click)="onNext()" type="button" [class.disable-click]="orders?.length===displayedRows" name="next"
        value="Next">
        Next
        <i class="fal fa-chevron-right ms-2"></i>
    </app-button>
</div>
<div class="orderSingleView d-flex align-items-center justify-content-center " *ngIf="this.orders.length>1">
    <p>Multi rows selected</p>
</div>

<div id="printSlip" class="d-none">
    <ng-container>
        <ng-template [cdkPortalOutlet]="packingSlipComponentPortal"
            (attached)="onPackingSlipComponentRendering($event)">
        </ng-template>
    </ng-container>
</div>